const rankingItems = [
  { rank: 1, title: '年度热门影视排行榜', heat: '本周最热', trend: 'hot' },
  { rank: 2, title: '高分纪录片人气榜', heat: '持续上升', trend: 'up' },
  { rank: 3, title: '热门综艺话题讨论', heat: '讨论量最高', trend: 'hot' },
  { rank: 4, title: '新番动漫追番热度', heat: '新上榜', trend: 'new' },
  { rank: 5, title: '短剧合集播放排行', heat: '稳定热播', trend: 'up' },
  { rank: 6, title: '音乐现场精选歌单', heat: '口碑推荐', trend: 'up' },
  { rank: 7, title: '游戏实况精彩集锦', heat: '弹幕互动多', trend: 'hot' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热度榜单
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            实时更新 · 全网用户最关注的内容方向
          </p>
        </div>
        <div className="bg-background-100 rounded-2xl border border-background-200 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-5 py-4 cursor-default transition-colors hover:bg-primary-50 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-white'
                    : item.rank === 2
                    ? 'bg-primary-300 text-white'
                    : item.rank === 3
                    ? 'bg-accent-500 text-white'
                    : 'bg-secondary-200 text-secondary-700'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm md:text-base font-bold text-foreground-900 truncate">
                  {item.title}
                </div>
              </div>
              <div className="flex items-center gap-1.5 shrink-0">
                {item.trend === 'hot' && (
                  <i className="ri-fire-line text-primary-500 text-sm"></i>
                )}
                {item.trend === 'new' && (
                  <i className="ri-sparkling-line text-accent-500 text-sm"></i>
                )}
                {item.trend === 'up' && (
                  <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                )}
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}